import { initializeApp, getApps, getApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";
import type { User } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBeu-i6ra8ZDkwvqJnBli9YWziv3PHqIbA",
  authDomain: "tm1-realtime.firebaseapp.com",
  databaseURL: "https://tm1-realtime-default-rtdb.firebaseio.com",
  projectId: "tm1-realtime",
  storageBucket: "tm1-realtime.firebasestorage.app",
  messagingSenderId: "311437554990",
  appId: "1:311437554990:web:65ae0e1f33a26a1a7b36bf",
  measurementId: "G-LBVWGZ16MH",
};

export const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const db = getDatabase(app);
export const auth = getAuth(app);

let authPromise: Promise<User | null> | null = null;

export function ensureFirebaseAuth(): Promise<User | null> {
  if (auth.currentUser) {
    return Promise.resolve(auth.currentUser);
  }

  if (authPromise) {
    return authPromise;
  }

  authPromise = new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      signInAnonymously(auth)
        .then((credential) => resolve(credential.user))
        .catch((error) => {
          authPromise = null;
          reject(error);
        });
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      unsubscribe();

      if (user) {
        resolve(user);
        return;
      }

      try {
        const credential = await signInAnonymously(auth);
        resolve(credential.user);
      } catch (error) {
        authPromise = null;
        reject(error);
      }
    }, (error) => {
      authPromise = null;
      reject(error);
    });
  });

  return authPromise;
}

if (typeof window !== "undefined") {
  // Inicia a sessao anonima automaticamente no cliente para respeitar regras do Firebase.
  void ensureFirebaseAuth();
}
